import { alertDateConstants } from '../constants/alert-date.constants';

const defaultState = {
  visible: false,
  data: null,
  isRequestForImmediate: false,
};

export function alertDate(state = defaultState, { type, payload = {} }) {
  switch (type) {
    case alertDateConstants.OPEN_MODAL:
      return {
        ...state,
        visible: true,
        ...payload,
      };
    case alertDateConstants.CLOSE_MODAL:
      return { ...defaultState };
    default:
      return state;
  }
}
